(() => {
  document.addEventListener('click', (event) => {
    const openButton = event.target.closest(
      '[data-insieme-allergen-open]'
    );

    if (openButton) {
      event.preventDefault();

      const dialogId =
        openButton.dataset.insiemeAllergenOpen;

      const dialog = document.getElementById(dialogId);

      if (dialog && typeof dialog.showModal === 'function') {
        dialog.insiemeTrigger = openButton;
        dialog.showModal();
      }

      return;
    }

    const closeButton = event.target.closest(
      '[data-insieme-allergen-close]'
    );

    if (closeButton) {
      event.preventDefault();

      const dialog = closeButton.closest('dialog');

      if (dialog) {
        dialog.close();
      }
    }
  });

  document.addEventListener('click', (event) => {
    const dialog = event.target;

    if (
      dialog.matches?.('[data-insieme-allergen-dialog]') &&
      event.target === dialog
    ) {
      dialog.close();
    }
  });

  document.addEventListener('close', (event) => {
    const dialog = event.target;

    if (
      dialog.matches?.('[data-insieme-allergen-dialog]') &&
      dialog.insiemeTrigger
    ) {
      dialog.insiemeTrigger.focus();
    }
  }, true);
})();